module.exports = __webpack_public_path__ + "img/inspection-large.2dc8dc1f.png";